module.exports = __webpack_public_path__ + "img/i2iSmall-transparent.c8ffca40.png";